import React from "react";

/**
 * AcrePulse brand mark: location pin with inner circle + ripple pulse rings.
 * Ripple rings gently pulse outwards by default (respects prefers-reduced-motion).
 * Pass `animated={false}` for a fully static rendering.
 */
export function LogoMark({ size = 32, color = "#F8FAFC", animated = true, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      {/* Ripple rings — echo the pulse */}
      <ellipse
        cx="32" cy="52" rx="22" ry="5"
        stroke={color} strokeWidth="2.4" opacity="0.95"
        className={animated ? "logo-ripple-a" : ""}
      />
      <ellipse
        cx="32" cy="55" rx="14" ry="3"
        stroke={color} strokeWidth="1.8" opacity="0.55"
        className={animated ? "logo-ripple-b" : ""}
      />
      {/* Pin body */}
      <path
        d="M32 4c-9.4 0-17 7.3-17 16.3 0 11.4 13.5 24 15.9 26.2a1.5 1.5 0 0 0 2 0C35.5 44.3 49 31.7 49 20.3 49 11.3 41.4 4 32 4Z"
        stroke={color}
        strokeWidth="3.2"
        fill="none"
        strokeLinejoin="round"
      />
      {/* Inner circle */}
      <circle cx="32" cy="20" r="6.4" stroke={color} strokeWidth="2.8" fill="none" />
    </svg>
  );
}

/**
 * Full brand lockup: mark + "AcrePulse" wordmark.
 * `tone`: "light" (white mark) | "brand" (Pulse Green mark)
 */
export default function Logo({ size = 32, textClass = "text-lg", tone = "light", animated = true }) {
  const markColor = tone === "brand" ? "#10B981" : "#F8FAFC";
  return (
    <div className="flex items-center gap-2.5">
      <LogoMark size={size} color={markColor} animated={animated} />
      <span
        className={`font-display font-semibold tracking-tight text-white ${textClass}`}
        style={{ letterSpacing: "-0.01em" }}
      >
        AcrePulse
      </span>
    </div>
  );
}
